import { render } from "./pediatrics_list.vue?vue&type=template&id=5a2c0f68&scoped=true"
import script from "./pediatrics_list.vue?vue&type=script&lang=js"
export * from "./pediatrics_list.vue?vue&type=script&lang=js"

import "./pediatrics_list.vue?vue&type=style&index=0&id=5a2c0f68&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2c0f68"]])

export default __exports__